import React from "react";

import { percentage } from "lib/common";

import { useRecoilValueLoadable, useSetRecoilState } from "recoil";
import { asyncGetPlan, asyncGetProfile } from "lib/store/user";
import { modalState } from "lib/store/common";

import { CurrentPlan } from "../CurrentPlan";

import "./Account.scss";

export const Account: React.FC = () => {
  const profile = useRecoilValueLoadable(asyncGetProfile);
  const plan = useRecoilValueLoadable(asyncGetPlan);
  const percentCalc = percentage(plan.contents.usage / plan.contents.limit, 0);
  const setModal = useSetRecoilState(modalState);
  return (
    <div className={`Account contents`}>
      {profile.state === "hasValue" && (
        <div className={"profile-wrapper"}>
          <div className={"profile"}>
            {profile.contents.username.charAt(0).toUpperCase()}
          </div>
          <div className="profile-list">
            <div className="profile-text">
              <span>{profile.contents.email}</span>
            </div>
            <div className="profile-text">
              <span>{profile.contents.username}</span>
            </div>
            {!profile.contents.social && (
              <div className="profile-text">
                <span>●●●●●●●●</span>
                <span
                  className={"click"}
                  onClick={() =>
                    setModal((_) => ({
                      ..._,
                      changePassword: true,
                      myAccount: false,
                    }))
                  }
                >
                  비밀번호 변경
                </span>
              </div>
            )}
          </div>
        </div>
      )}
      <CurrentPlan />
      {plan.state === "hasValue" && (
        <>
          <div className="usage">
            <span className="title">Usage</span>
            <div className="body">
              <div className="top">
                <span>현재 사용량</span>
                <span>
                  {plan.contents.usage.toLocaleString()} /
                  {plan.contents.limit.toLocaleString()}
                </span>
              </div>
              <div className="ProgressBar">
                <div
                  className="bar"
                  style={{
                    width: `${
                      parseInt(percentCalc) > 100 ? 100 : percentCalc
                    }%`,
                    backgroundColor:
                      parseInt(percentCalc) > 100 ? "#E82C20" : "#111",
                  }}
                />
                <span className={"percent"}>{percentCalc}%</span>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
